import React from "react";
import {
  facebook,
  instagram,
  linkedin,
  twitter,
  web,
} from "../../../../core/assets/icons";


interface Step1Props {
data: any
}

const Aside: React.FC<Step1Props> = ({data}) => {


  

  return (
    <>
      <div className="dahboard-main-side d-none d-lg-block">
        <div className="dahboard-main-side-content grid-auto">
          <div className="dahboard-main-side-content-first grid-auto">
            <div className="side-img-box mt-10">
              <svg
                width="105"
                height="100"
                viewBox="0 0 105 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="50.5" cy="50" r="50" fill="#F2F2F2" />
                <path
                  d="M27.0215 71.9062C27.0757 67.803 28.7432 63.8861 31.6632 61.0029C34.5833 58.1197 38.521 56.5021 42.6246 56.5H61.3746C65.4782 56.5021 69.416 58.1197 72.336 61.0029C75.256 63.8861 76.9235 67.803 76.9777 71.9062C70.1241 78.0823 61.2254 81.5002 51.9996 81.5002C42.7738 81.5002 33.8751 78.0823 27.0215 71.9062ZM66.0621 33.0625C66.0621 35.8438 65.2374 38.5626 63.6922 40.8752C62.1469 43.1878 59.9507 44.9902 57.3811 46.0546C54.8115 47.1189 51.984 47.3974 49.2562 46.8548C46.5283 46.3122 44.0226 44.9729 42.0559 43.0062C40.0892 41.0395 38.7499 38.5338 38.2073 35.806C37.6647 33.0781 37.9432 30.2506 39.0076 27.681C40.0719 25.1114 41.8743 22.9152 44.1869 21.37C46.4995 19.8248 49.2183 19 51.9996 19C55.7292 19 59.3061 20.4816 61.9433 23.1188C64.5805 25.756 66.0621 29.3329 66.0621 33.0625Z"
                  fill="#D9D9D9"
                />
                <circle
                  cx="91.5"
                  cy="84"
                  r="12"
                  fill="#6366F1"
                  stroke="#F2F2F2"
                  strokeWidth="3"
                />
                <path
                  d="M94.7593 81.0769H93.5L93.2 80.2038C93.1793 80.1441 93.1413 80.0925 93.0912 80.056C93.0412 80.0195 92.9815 79.9999 92.9204 80H90.0796C89.9546 80 89.8426 80.0817 89.8009 80.2038L89.5 81.0769H88.2407C87.8315 81.0769 87.5 81.4212 87.5 81.8462V86.2308C87.5 86.6558 87.8315 87 88.2407 87H94.7593C95.1685 87 95.5 86.6558 95.5 86.2308V81.8462C95.5 81.4212 95.1685 81.0769 94.7593 81.0769ZM91.5 85.4615C90.6815 85.4615 90.0185 84.7731 90.0185 83.9231C90.0185 83.0731 90.6815 82.3846 91.5 82.3846C92.3185 82.3846 92.9815 83.0731 92.9815 83.9231C92.9815 84.7731 92.3185 85.4615 91.5 85.4615ZM90.6111 83.9231C90.6111 84.1679 90.7048 84.4027 90.8715 84.5758C91.0382 84.7489 91.2643 84.8462 91.5 84.8462C91.7357 84.8462 91.9618 84.7489 92.1285 84.5758C92.2952 84.4027 92.3889 84.1679 92.3889 83.9231C92.3889 83.6783 92.2952 83.4435 92.1285 83.2704C91.9618 83.0973 91.7357 83 91.5 83C91.2643 83 91.0382 83.0973 90.8715 83.2704C90.7048 83.4435 90.6111 83.6783 90.6111 83.9231Z"
                  fill="white"
                />
              </svg>
              {/* <div>Ministry of Education</div> */}
            </div>
            <div className="side-text-container mb-10">
              <div> {data?.registeredName} </div>
            </div>
          </div>
          <div className="dashboard-main-side-center">
            <div>
              <svg
                width="11"
                height="14"
                viewBox="0 0 11 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "1rem" }}
              >
                <path
                  d="M3.25632 14H7.13478V7.6125H10.3779L10.8676 5.1275H7.13478V3.535C7.13478 2.8175 7.43923 2.3275 9.0012 2.3275H11V0.0962499C10.6558 0.0699999 9.47774 0 8.10108 0C5.2154 0 3.25632 1.16375 3.25632 3.29V5.1275H0V7.6125H3.25632V14Z"
                  fill="#6366F1"
                />
              </svg>
              <span className="dashboard-socail-links-text">
                {" "}
                 {data?.contact?.twitterHandle}
              </span>
            </div>
            <div>
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "1rem" }}
              >
                <path
                  d="M13 1.66303C12.5219 1.9364 12.0017 2.13314 11.4658 2.20977C12.0222 1.77162 12.4388 1.07942 12.6375 0.263026C12.1155 0.674719 11.5435 0.963406 10.9471 1.11628C10.6978 0.763021 10.3964 0.4816 10.0615 0.28955C9.72654 0.0975012 9.36538 -0.00105991 9.00048 8.5955e-06C7.5241 8.5955e-06 6.33674 1.5864 6.33674 3.53314C6.33674 3.80651 6.36174 4.07989 6.40236 4.34291C4.19168 4.18965 2.22005 2.78965 0.909266 0.646162C0.670428 1.18693 0.545268 1.80266 0.546809 2.4293C0.546809 3.65533 1.01707 4.7364 1.73417 5.37219C1.31157 5.35013 0.898865 5.19616 0.529624 4.92279V4.96628C0.529624 6.68314 1.44514 8.10592 2.6653 8.43314C2.43621 8.51203 2.20053 8.55238 1.96383 8.55326C1.79041 8.55326 1.62637 8.53048 1.46076 8.49941C1.79822 9.89941 2.78092 10.9163 3.95109 10.9494C3.03557 11.9 1.88884 12.4592 0.643673 12.4592C0.420262 12.4592 0.214037 12.4488 0 12.4157C1.18111 13.4201 2.5825 14 4.0917 14C8.99111 14 11.672 8.61953 11.672 3.94941C11.672 3.79616 11.672 3.64291 11.6642 3.48965C12.1829 2.9864 12.6375 2.36302 13 1.66303Z"
                  fill="#6366F1"
                />
              </svg>
              <span className="dashboard-socail-links-text">
                {" "}
                 {data?.contact?.twitterHandle}
              </span>
            </div>
            <div>
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "1rem" }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.82023 0.539C4.51336 0.507091 4.73436 0.5 6.5 0.5C8.26564 0.5 8.48664 0.507682 9.17918 0.539C9.87173 0.570318 10.3445 0.680818 10.7581 0.840955C11.1912 1.00464 11.5842 1.2605 11.9092 1.59141C12.2401 1.91582 12.4954 2.30818 12.6585 2.74191C12.8192 3.15555 12.9291 3.62827 12.961 4.31964C12.9929 5.01395 13 5.23495 13 7C13 8.76564 12.9923 8.98664 12.961 9.67977C12.9297 10.3711 12.8192 10.8439 12.6585 11.2575C12.4954 11.6913 12.2397 12.0843 11.9092 12.4092C11.5842 12.7401 11.1912 12.9954 10.7581 13.1585C10.3445 13.3192 9.87173 13.4291 9.18036 13.461C8.48664 13.4929 8.26564 13.5 6.5 13.5C4.73436 13.5 4.51336 13.4923 3.82023 13.461C3.12886 13.4297 2.65614 13.3192 2.2425 13.1585C1.80873 12.9953 1.41571 12.7396 1.09082 12.4092C0.760134 12.0846 0.504231 11.6917 0.340955 11.2581C0.180818 10.8445 0.0709091 10.3717 0.039 9.68036C0.0070909 8.98604 0 8.76505 0 7C0 5.23436 0.00768181 5.01336 0.039 4.32082C0.0703182 3.62827 0.180818 3.15555 0.340955 2.74191C0.504473 2.30823 0.76057 1.91541 1.09141 1.59082C1.41584 1.26021 1.80846 1.00431 2.24191 0.840955C2.65555 0.680818 3.12827 0.570909 3.81964 0.539H3.82023ZM9.12659 1.709C8.44114 1.67768 8.2355 1.67118 6.5 1.67118C4.7645 1.67118 4.55886 1.67768 3.87341 1.709C3.23936 1.73795 2.89545 1.84373 2.66618 1.93295C2.36305 2.05114 2.14618 2.19118 1.91868 2.41868C1.70303 2.62849 1.53706 2.88389 1.43295 3.16618C1.34373 3.39545 1.23795 3.73936 1.209 4.37341C1.17768 5.05886 1.17118 5.2645 1.17118 7C1.17118 8.7355 1.17768 8.94114 1.209 9.62659C1.23795 10.2606 1.34373 10.6045 1.43295 10.8338C1.53695 11.1157 1.703 11.3715 1.91868 11.5813C2.12845 11.797 2.38432 11.963 2.66618 12.067C2.89545 12.1563 3.23936 12.262 3.87341 12.291C4.55886 12.3223 4.76391 12.3288 6.5 12.3288C8.23609 12.3288 8.44114 12.3223 9.12659 12.291C9.76064 12.262 10.1045 12.1563 10.3338 12.067C10.637 11.9489 10.8538 11.8088 11.0813 11.5813C11.297 11.3715 11.463 11.1157 11.567 10.8338C11.6563 10.6045 11.762 10.2606 11.791 9.62659C11.8223 8.94114 11.8288 8.7355 11.8288 7C11.8288 5.2645 11.8223 5.05886 11.791 4.37341C11.762 3.73936 11.6563 3.39545 11.567 3.16618C11.4489 2.86305 11.3088 2.64618 11.0813 2.41868C10.8715 2.20304 10.6161 2.03708 10.3338 1.93295C10.1045 1.84373 9.76064 1.73795 9.12659 1.709V1.709ZM5.66977 9.00377C6.13343 9.19678 6.64972 9.22283 7.13046 9.07747C7.61119 8.93211 8.02655 8.62436 8.30559 8.20678C8.58462 7.7892 8.71003 7.2877 8.66039 6.78793C8.61075 6.28815 8.38914 5.82112 8.03341 5.46659C7.80664 5.23996 7.53244 5.06643 7.23056 4.9585C6.92868 4.85056 6.60662 4.81089 6.28757 4.84236C5.96851 4.87383 5.66041 4.97565 5.38543 5.14049C5.11045 5.30532 4.87544 5.52908 4.69732 5.79564C4.51919 6.0622 4.40238 6.36494 4.3553 6.68207C4.30823 6.99919 4.33204 7.32281 4.42505 7.62962C4.51805 7.93644 4.67792 8.21881 4.89315 8.45643C5.10839 8.69404 5.37362 8.88097 5.66977 9.00377ZM4.13755 4.63755C4.44779 4.3273 4.8161 4.08121 5.22145 3.9133C5.6268 3.7454 6.06125 3.65898 6.5 3.65898C6.93875 3.65898 7.3732 3.7454 7.77855 3.9133C8.1839 4.08121 8.55221 4.3273 8.86245 4.63755C9.1727 4.94779 9.41879 5.3161 9.5867 5.72145C9.7546 6.1268 9.84101 6.56125 9.84101 7C9.84101 7.43875 9.7546 7.8732 9.5867 8.27855C9.41879 8.6839 9.1727 9.05221 8.86245 9.36245C8.23589 9.98902 7.38609 10.341 6.5 10.341C5.61391 10.341 4.76411 9.98902 4.13755 9.36245C3.51098 8.73589 3.15898 7.88609 3.15898 7C3.15898 6.11391 3.51098 5.26411 4.13755 4.63755V4.63755ZM10.582 4.15655C10.6589 4.08402 10.7204 3.99681 10.763 3.90008C10.8056 3.80334 10.8283 3.69905 10.8298 3.59337C10.8314 3.48769 10.8117 3.38278 10.772 3.28484C10.7322 3.18691 10.6733 3.09794 10.5985 3.0232C10.5238 2.94847 10.4348 2.88949 10.3369 2.84976C10.2389 2.81003 10.134 2.79035 10.0284 2.79189C9.92268 2.79343 9.81839 2.81616 9.72165 2.85873C9.62492 2.9013 9.5377 2.96285 9.46518 3.03973C9.32414 3.18924 9.24692 3.38784 9.24991 3.59337C9.25291 3.79889 9.33589 3.99516 9.48123 4.1405C9.62657 4.28584 9.82284 4.36882 10.0284 4.37181C10.2339 4.37481 10.4325 4.29759 10.582 4.15655V4.15655Z"
                  fill="#6366F1"
                />
              </svg>
              <span className="dashboard-socail-links-text">
                {" "}
                  {data?.contact?.twitterHandle}
              </span>
            </div>
            <div>
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "1rem" }}
              >
                <path
                  d="M2.72823 1.94509C2.72805 2.32816 2.58415 2.69546 2.32821 2.96619C2.07226 3.23693 1.72522 3.38892 1.36343 3.38873C1.00165 3.38854 0.65475 3.23618 0.399057 2.96517C0.143364 2.69417 -0.000180722 2.32671 1.70761e-07 1.94364C0.000181063 1.56057 0.144073 1.19327 0.400022 0.922534C0.655971 0.651798 1.00301 0.499809 1.3648 0.5C1.72658 0.500192 2.07348 0.652549 2.32917 0.923555C2.58486 1.19456 2.72841 1.56202 2.72823 1.94509ZM2.76915 4.45828H0.0409235V13.5H2.76915V4.45828ZM7.07975 4.45828H4.36516V13.5H7.05247V8.75526C7.05247 6.11208 10.3059 5.86654 10.3059 8.75526V13.5H13V7.7731C13 3.31723 8.18468 3.48333 7.05247 5.67155L7.07975 4.45828Z"
                  fill="#6366F1"
                />
              </svg>
              <span className="dashboard-socail-links-text">
                {" "}
                 {data?.contact?.twitterHandle}
              </span>
            </div>
            <div>
              <svg
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "1rem" }}
              >
                <path
                  d="M7.5 13.5C11.0899 13.5 14 10.5899 14 7C14 3.41015 11.0899 0.5 7.5 0.5C3.91015 0.5 1 3.41015 1 7C1 10.5899 3.91015 13.5 7.5 13.5Z"
                  stroke="#6366F1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 7H14M10 7C9.8772 9.37699 9.00168 11.6533 7.5 13.5C5.99832 11.6533 5.1228 9.37699 5 7C5.1228 4.62301 5.99832 2.34665 7.5 0.5C9.00168 2.34665 9.8772 4.62301 10 7Z"
                  stroke="#6366F1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="dashboard-socail-links-text">
                {" "}
              {data?.contact?.websiteUrl}
              </span>
            </div>
          </div>
          <div></div>
        </div>
      </div>

      <div className="d-medium">
        <div className="w-100 bg-white h-120 d-flex justify-content-center align-items-center ">
          <div>
            <svg
              width="82"
              height="82"
              viewBox="0 0 82 82"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="40" fill="#F2F2F2" />
              <path
                d="M24 53.8599C24.0347 51.2338 25.1019 48.727 26.9707 46.8818C28.8395 45.0365 31.3597 44.0013 33.986 43.9999H45.9859C48.6122 44.0013 51.1324 45.0365 53.0012 46.8818C54.87 48.727 55.9372 51.2338 55.9719 53.8599C51.5856 57.8125 45.8904 60 39.9859 60C34.0814 60 28.3863 57.8125 24 53.8599ZM48.9859 29C48.9859 30.78 48.4581 32.52 47.4691 34.0001C46.4802 35.4801 45.0746 36.6337 43.4301 37.3148C41.7855 37.996 39.976 38.1743 38.2301 37.827C36.4843 37.4797 34.8807 36.6226 33.622 35.3639C32.3633 34.1052 31.5062 32.5016 31.1589 30.7558C30.8116 29.01 30.9899 27.2004 31.6711 25.5558C32.3522 23.9113 33.5058 22.5057 34.9858 21.5168C36.4659 20.5278 38.2059 20 39.9859 20C42.3729 20 44.6621 20.9482 46.3499 22.636C48.0377 24.3239 48.9859 26.613 48.9859 29Z"
                fill="#D9D9D9"
              />
              <circle
                cx="68"
                cy="68"
                r="12"
                fill="#6366F1"
                stroke="#F2F2F2"
                strokeWidth="3"
              />
              <path
                d="M71.2593 65.0769H70L69.7 64.2038C69.6793 64.1441 69.6413 64.0925 69.5912 64.056C69.5412 64.0195 69.4815 63.9999 69.4204 64H66.5796C66.4546 64 66.3426 64.0817 66.3009 64.2038L66 65.0769H64.7407C64.3315 65.0769 64 65.4212 64 65.8462V70.2308C64 70.6558 64.3315 71 64.7407 71H71.2593C71.6685 71 72 70.6558 72 70.2308V65.8462C72 65.4212 71.6685 65.0769 71.2593 65.0769ZM68 69.4615C67.1815 69.4615 66.5185 68.7731 66.5185 67.9231C66.5185 67.0731 67.1815 66.3846 68 66.3846C68.8185 66.3846 69.4815 67.0731 69.4815 67.9231C69.4815 68.7731 68.8185 69.4615 68 69.4615ZM67.1111 67.9231C67.1111 68.1679 67.2048 68.4027 67.3715 68.5758C67.5382 68.7489 67.7643 68.8462 68 68.8462C68.2357 68.8462 68.4618 68.7489 68.6285 68.5758C68.7952 68.4027 68.8889 68.1679 68.8889 67.9231C68.8889 67.6783 68.7952 67.4435 68.6285 67.2704C68.4618 67.0973 68.2357 67 68 67C67.7643 67 67.5382 67.0973 67.3715 67.2704C67.2048 67.4435 67.1111 67.6783 67.1111 67.9231Z"
                fill="white"
              />
            </svg>
          </div>

          <div className="d-flex flex-column justify-content-center ps-5">
            <span className="fw-boldest fs-8 ">Ministry of Education</span>
            <div className="d-flex mt-5">
              <img src={web} className="dashboard-icon ps-0" />
              <img src={facebook} className="dashboard-icon" />
              <img src={linkedin} className="dashboard-icon" />
              <img src={twitter} className="dashboard-icon" />
              <img src={instagram} className="dashboard-icon" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Aside };
